import {FC} from "react";
import {useApiCall} from "../../../../lib/src/api";
import {config} from "../../config";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";


export const BulkDeleteLearnCategoryModal: FC<{ selected: string[], reload: () => void }> = (props) => {
  const { learn } = useApiCall(config)
  const archive = async () => {
    const promises = props.selected.map(async (category) => {
      await learn.deleteCategory(category)
    })
    await Promise.all(promises)
    props.reload()
  }

  return <>
    <div>Je staat op het punt om {props.selected.length} categorieën te verwijderen. Doorgaan?</div>
    <ModalFooter text={'Verwijder'} onSubmit={archive} />
  </>
}